/** Set-specific progressive enhancement; Horizon owns every cart request. */
function initSet(root) {
  if (root.dataset.psReady) return;
  const component = root.querySelector("product-form-component");
  const form = component?.querySelector("form");
  const submit = form?.querySelector("button[type=\"submit\"]");
  if (!form || !submit) return;
  root.dataset.psReady = "true";
  const feedback = root.querySelector("[data-pp-feedback]");
  const sticky = root.querySelector("[data-pp-sticky]");
  const stickyButton = root.querySelector("[data-pp-sticky-add]");
  const stickyFeedback = root.querySelector("[data-pp-sticky-feedback]");
  const quantity = form.querySelector("[name=\"quantity\"]");
  let pending = false;
  let timeout;
  const say = (message, error = false) => {
    [feedback, stickyFeedback].forEach(node => {
      if (!node) return;
      node.textContent = message;
      node.classList.toggle("is-error", error);
    });
  };
  const finish = (message, error = false) => {
    if (!pending) return;
    pending = false;
    clearTimeout(timeout);
    component.removeAttribute("aria-busy");
    if (stickyButton) stickyButton.disabled = submit.disabled;
    say(message, error);
  };
  form.addEventListener("submit", event => {
    if (pending || submit.disabled || !form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const validation = component.querySelector("quantity-selector-component")?.canAddToCart?.();
    if (validation && !validation.canAdd) {
      // Native validation does not emit a cart event when the limit is reached.
      say(`Puoi avere nel carrello al massimo ${validation.maxQuantity} set.`, true);
      return;
    }
    pending = true;
    component.setAttribute("aria-busy", "true");
    if (stickyButton) stickyButton.disabled = true;
    say("Aggiunta del set al carrello in corso …");
    timeout = setTimeout(() => finish("Controlla il carrello prima di aggiungere nuovamente il set.", true), 25000);
  });
  component.addEventListener("cart:update", event => {
    if (event.target !== component) return;
    finish(event.detail?.data?.didError ? "" : "Il tuo set è nel carrello. Buona pittura!", Boolean(event.detail?.data?.didError));
  });
  component.addEventListener("cart:error", event => {
    if (event.target === component) finish("Non è stato possibile aggiungere il set. Controlla il messaggio accanto al pulsante d’acquisto.", true);
  });
  new MutationObserver(() => {
    if (stickyButton) stickyButton.disabled = pending || submit.disabled;
  }).observe(submit, { attributes: true, attributeFilter: ["disabled"] });
  const updateQuantity = () => {
    const count = root.querySelector("[data-pp-sticky-quantity]");
    if (count && quantity?.checkValidity()) count.textContent = `${quantity.value} × `;
  };
  quantity?.addEventListener("input", updateQuantity);
  quantity?.addEventListener("change", updateQuantity);
  component.addEventListener("quantity-selector:update", updateQuantity);
  if (quantity) new MutationObserver(updateQuantity).observe(quantity, { attributes: true, attributeFilter: ["data-cart-quantity"] });
  stickyButton?.addEventListener("click", () => {
    if (!form.reportValidity()) {
      component.scrollIntoView({ block: "center", behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
      return;
    }
    if (!pending && !submit.disabled) submit.click();
  });
  if (sticky && "IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(component);
  }
}
const start = () => document.querySelectorAll("[data-panart-set]").forEach(initSet);
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
else start();
document.addEventListener("shopify:section:load", start);
